import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
    providedIn: 'root'
})
export class BlockComponentQuery extends Query<any> {
    document = gql`
        query Turbines($serialNav: Float!, $code: String!) {
            turbines(where: { serialNav: $serialNav }) {
              logbookComponentsByAlarmCode(alarm_code: $code) {
                alarm_code
                description
              }
            }
        }
    `;
}
